import { j as e } from "../../jsx-runtime-ClSzPYp4.js";
import { styled as t } from "styled-components";
import { compose as n, flexbox as p, layout as s, space as f } from "styled-system";
import c from "../BaseLogo.mjs";
import d from "../CapitalOne/assets/CapitalOneSvg.mjs";
import l from "./assets/PostOfficeSvg.mjs";
const g = /* @__PURE__ */ t.div.withConfig({
  shouldForwardProp: (o) => ![
    "flexDirection"
  ].includes(o)
}).withConfig({
  componentId: "sc-337e49d8-0"
})([
  "",
  " ",
  ""
], ({ theme: o }) => o.components.logo.postOffice.wrapper, n(p, s, f)), m = /* @__PURE__ */ t.div.withConfig({
  componentId: "sc-337e49d8-1"
})([
  "",
  ""
], ({ theme: o }) => o.components.logo.postOffice.postOfficeWrapper), w = /* @__PURE__ */ t.div.withConfig({
  componentId: "sc-337e49d8-2"
})([
  "",
  ""
], ({ theme: o }) => o.components.logo.postOffice.capitalOneWrapper), x = /* @__PURE__ */ t.span.withConfig({
  componentId: "sc-337e49d8-3"
})([
  "",
  ""
], ({ theme: o }) => o.components.logo.postOffice.poweredByText), h = ({ LogoWrapper: o = g, PostOfficeLogoWrapper: i = m, CapitalOneLogoWrapper: r = w, ...a }) => /* @__PURE__ */ e.jsxs(o, {
  "aria-label": "Post Office powered by Capital One Logo",
  ...a,
  role: void 0,
  children: [
    /* @__PURE__ */ e.jsx(i, {
      children: /* @__PURE__ */ e.jsx("a", {
        "data-qa-id": "post-office-link",
        href: "https://www.postoffice.co.uk",
        target: "_blank",
        rel: "noopener noreferrer",
        children: /* @__PURE__ */ e.jsx(l, {
          "data-qa-id": "post-office-logo-svg"
        })
      })
    }),
    /* @__PURE__ */ e.jsxs(r, {
      children: [
        /* @__PURE__ */ e.jsx(x, {
          "data-qa-id": "powered-by-text",
          children: "Powered by"
        }),
        /* @__PURE__ */ e.jsx("a", {
          "data-qa-id": "capital-one-link",
          href: "https://www.capitalone.co.uk",
          target: "_blank",
          rel: "noopener noreferrer",
          children: /* @__PURE__ */ e.jsx(d, {
            "data-qa-id": "capital-one-logo-svg"
          })
        })
      ]
    })
  ]
}), b = (o) => /* @__PURE__ */ e.jsx(c, {
  RenderedLogo: h,
  "data-qa-id": "post-office-logo",
  ...o
});
export {
  h as BasePostOfficeLogo,
  w as DefaultCapitalOneLogoWrapper,
  g as DefaultLogoWrapper,
  m as DefaultPostOfficeLogoWrapper,
  x as PoweredByText,
  b as default
};
